import type { MemberWorkSchedulesQueryParams } from '../types';

export const WORK_SCHEDULES_KEYS = {
  all: ['work-schedules'] as const,
  tenant: (orgId: string) => ['work-schedules', 'tenant', orgId] as const,
  members: (orgId: string) => ['work-schedules', 'members', orgId] as const,
  membersList: (orgId: string, params: MemberWorkSchedulesQueryParams) =>
    ['work-schedules', 'members', orgId, 'list', params] as const,
  member: (orgId: string, userId: string) => ['work-schedules', 'member', orgId, userId] as const,
};
